module.exports = __webpack_public_path__ + "img/nano-crawler-prizz-logo.ee1bf324.png";